import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { Team, PaginatedResponse, ApiResponse } from '@com.maessa.payroll.frontend/models';

export interface TeamPayload {
  name: string;
  code: string;
  site_id: number;
  leader_id: number | null;
  active: boolean;
}

@Injectable({ providedIn: 'root' })
export class TeamApiService extends BaseApiService {
  getTeams(filters?: { site_id?: number; active?: boolean }): Observable<PaginatedResponse<Team>> {
    const params = this.buildParams(filters ?? {});
    return this.get<PaginatedResponse<Team>>(`${this.baseUrl}/teams`, params);
  }

  getTeam(id: number): Observable<ApiResponse<Team>> {
    return this.get<ApiResponse<Team>>(`${this.baseUrl}/teams/${id}`);
  }

  createTeam(payload: TeamPayload): Observable<ApiResponse<Team>> {
    return this.post<ApiResponse<Team>>(`${this.baseUrl}/teams`, payload);
  }

  updateTeam(id: number, payload: Partial<TeamPayload>): Observable<ApiResponse<Team>> {
    return this.put<ApiResponse<Team>>(`${this.baseUrl}/teams/${id}`, payload);
  }

  deleteTeam(id: number): Observable<void> {
    return this.delete<void>(`${this.baseUrl}/teams/${id}`);
  }

  addMember(teamId: number, employeeId: number): Observable<ApiResponse<Team>> {
    return this.post<ApiResponse<Team>>(
      `${this.baseUrl}/teams/${teamId}/members`,
      { employee_id: employeeId }
    );
  }

  removeMember(teamId: number, employeeId: number): Observable<void> {
    return this.delete<void>(`${this.baseUrl}/teams/${teamId}/members/${employeeId}`);
  }
}
